module.exports = __webpack_public_path__ + "img/intro.df9a4c6e.jpg";